export default __webpack_public_path__ + "media/zurb/img/bryan/thumbs/9-e5c9510539226a6667613f32d0d34958.png";